import React from 'react';
import PropTypes from 'prop-types';

import { CustomFormLabel } from 'components';
import { FormControl, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';

const CustomDatePicker = props => {
    const { label, error, showError, inputStyle, fullWidth, controlSx, ...rest } = props;

    return (
        <FormControl
            sx={controlSx}
            error={!!error}
            classes={{ root: inputStyle }}
            fullWidth={fullWidth}
        >
            {label && <CustomFormLabel>{label}</CustomFormLabel>}
            <DatePicker
                {...rest}
                autoOk
                orientation="portrait"
                format="DD/MM/yyyy"
                FormHelperTextProps={{ style: { marginLeft: 0 } }}
                error={!!error}
                helperText={showError && error ? error : ''}
                renderInput={params => (
                    <TextField
                        {...params}
                        sx={{
                            '& .MuiOutlinedInput-root': { paddingRight: '14px' },
                            marginBottom: 0,
                            ...rest.sx,
                        }}
                        error={!!error}
                        variant="outlined"
                        inputProps={{ ...params.inputProps, placeholder: 'JJ/MM/AAAA' }}
                    />
                )}
            />
            {!!error && showError && <FormHelperText error={!!error}>{error}</FormHelperText>}
        </FormControl>
    );
};

CustomDatePicker.propTypes = {
    showError: PropTypes.bool,
    inputStyle: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
};

export default CustomDatePicker;
